import { IonContent } from '@ionic/react';
import React from 'react';

import { webCampaign } from '@/modules/webCampaign';

import { Content } from './components/Content';
import { MainImage } from './components/MainImage';
import { Title } from './components/Title';
import { PageStyles } from './Default.styles';

const DefaultVariant: React.FC = () => {
  return (
    <PageStyles background={webCampaign.getStaticTheme()}>
      <IonContent>
        <Title />

        <MainImage />

        <Content />
      </IonContent>
    </PageStyles>
  );
};

export default DefaultVariant;
